import { AssessmentObjective } from "./assessment-objective";
import { ProjectPart } from "./project-part";

export class AssessmentGoal extends ProjectPart {
  goalData : {
    title: string,
    description: string
  };
  sortOrder : string;
  newAddedID: number;
  goalObjectiveList: AssessmentObjective[];

  expanded: boolean = true;
  isBeingEdited: boolean = false;

  titleDisabled: boolean = false;
  descriptionDisabled: boolean = false;

  showIlo: boolean = false;

  constructor(
    id:number = 0,
    title: string = "",
    description: string = "",
    requestKey: string = "",
    sortOrder: string = "",
    newAddedID: number = 0,
    goalObjectiveList: AssessmentObjective[] = [],
    expanded: boolean = true,
    titleDisabled: boolean = false,
    descriptionDisabled: boolean = false
  ) {
    super("goal", id, requestKey, expanded);
    this.goalData = {
      title: title,
      description: description
    };
    this.sortOrder = sortOrder;
    this.newAddedID = newAddedID;
    this.goalObjectiveList = goalObjectiveList;

    this.titleDisabled = titleDisabled;
    this.descriptionDisabled = descriptionDisabled;
  }

  getHtmlId() {
    if( typeof(this.htmlId) == undefined ) {
      this.generateHtmlId();
    }
    return this.htmlId;
  }
}
